import React from 'react';
import styles from './Button.module.css';

interface ButtonProps {
  children: React.ReactNode;
  type?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({ children, type = 'primary', onClick, disabled = false, className }) => {
  return (
    <button className={`${styles.button} ${styles[type]} ${className || ''}`} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

export default Button;
